import { ReactNode } from 'react';
import { IconCaret, IconLock } from '@components/icons';
import { PillToggle, PillToggleVariant, SIZE_S } from '@components/pill-toggle';

export interface FormFieldRowLockedProps {
  label: ReactNode;
  requirementVariant: PillToggleVariant;
  requirementLabel: string;
}

export const FormFieldRowLocked = ({ label, requirementVariant, requirementLabel }: FormFieldRowLockedProps) => (
  <>
    <div className='hidden min-w-0 flex-1 items-center gap-1 px-3 xs:flex'>
      <span className='text-body-m whitespace-nowrap text-tertiary'>{label}</span>
      <IconLock aria-hidden className='h-3 w-3 shrink-0 text-tertiary' />
    </div>
    <div className='hidden items-center justify-end px-3 xs:flex'>
      <PillToggle variant={requirementVariant} label={requirementLabel} size={SIZE_S} className='opacity-50' />
    </div>

    <div className='flex w-full items-center xs:hidden' aria-disabled='true' data-testid='form-field-row-mobile-locked'>
      <div className='flex min-w-0 flex-1 items-center gap-1 px-2'>
        <span className='text-body-m truncate text-tertiary'>{label}</span>
        <IconLock aria-hidden className='h-3 w-3 shrink-0 text-tertiary' />
      </div>
      <div className='flex shrink-0 items-center gap-2 px-2'>
        <PillToggle variant={requirementVariant} label={requirementLabel} size={SIZE_S} className='opacity-50' />
        <IconCaret aria-hidden className='h-4 w-4 text-tertiary' />
      </div>
    </div>
  </>
);
